import { contractFormToQuery as formToQuery } from './contractFormToQuery';
import { contractQueryToForm as queryToForm } from './contractQueryToForm';

export default { queryToForm, formToQuery };
